import { getSintegradaServerApi } from "@/services/api";

type Params = {
	cnes?: string;
	ibgeCode?: string;
	page?: number;
	per_page?: number;
	search?: string;
	startDate: string;
	endDate: string;
	sexo?: string;
	icd_code?: string;
	icd_description?: string;
	minAge?: string;
	maxAge?: string;
	riskClassificationId?: number;
	professionalId?: number;
	specialty_id?: number;
	department?: number;
	group_by?: string;
	all_results?: number;
};

export async function getDiagnosticHypothesis({ ibgeCode, ...params }: Params) {
	const url = "/diagnostic-hypothesis";

	const { data } = await getSintegradaServerApi().get(url, {
		ibgeCode,
		...params,
	});

	return data;
}
